class AccountSettings.InstagramListeningEndpointsView extends Backbone.View
  template: JST['backbone/templates/account_settings/topics/instagram_listening_endpoints']
  events:
    'click #most-recents': 'onClickMostRecents'
    'click #most-populars': 'onClickMostPopulars'

  initialize:(endpointSelected)->
    @endpointSelected = endpointSelected || 'most-recents'

  render:->
    @$el.html(@template())
    @$('select option[value='+ @endpointSelected + ']').attr("selected",true);
    @

  onClickMostRecents:(event)->
    event.preventDefault()
    @endpointSelected = 'most-recents'
    @trigger('listening:endpoint:change', 'most-recents')

  onClickMostPopulars:(event)->
    event.preventDefault()
    @endpointSelected = 'most-populars'
    @trigger('listening:endpoint:change', 'most-populars')

  getEndpointSelected:->
    @endpointSelected
